import { HomeLayout } from "../shared-components/ViewFragments/Home/web";
import React from "react";
import { withApollo } from "../lib/apollo3";
import { withAuth } from "../lib/auth";
import { withContext } from "../lib/context";
import { withGlobalComponents } from "../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../shared-components/i18n";
import { decodeHashUrl } from "@Utils/Functions";
import AdvertiserProvider from "src/contexts/AdvertiserContext";
import getConfig from "next/config";
import { getProjectsSSR } from "src/services/search";

const { mainDomain } = getConfig().publicRuntimeConfig;

// Home Page
const Home = (props) => {
	return (
		<AdvertiserProvider>
			<HomeLayout projectsResult={props?.projectsResult} />
			{/* <RTBhouse page={"home"} /> */}
		</AdvertiserProvider>
	);
};

Home.getInitialProps = async function({ req, query }) {
	const HomeFiltersInitVal = {
		operation_type_id: { text: "Venta", value: 1 },
		property_type_id: [
			{ text: "Casas", value: 1 },
			{ text: "Apartamentos", value: 2 },
		],
		season: null,
		dateFrom: null,
		dateTo: null,
	};
	const q = query.hashed ? decodeHashUrl(query.hashed) : null;

	let projectsResult = null;
	if (q?.configs?.country_code === "CO") {
		try {
			const [vis, nonVis] = await Promise.all([
				getProjectsSSR(mainDomain, 8, { socialHousing: true }),
				getProjectsSSR(mainDomain, 8, { socialHousing: false }),
			]);
			projectsResult = { vis, nonVis };
		} catch (e) {
			projectsResult = null;
		}
	}

	return {
		FiltersContextInitialState: HomeFiltersInitVal,
		ConfigContextInitialState: q?.configs,
		CurrentUrlContextInitialState: {
			url: typeof window !== "undefined" ? window.location.href : req.url,
		},
		projectsResult,
	};
};

export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(Home))), {
		withDummyContext: false,
		withFiltersContext: true,
		withConfigContext: true,
		withThemeContext: true,
	})
);

